import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { TextField } from "@mui/material";
import jsonEquals from "../../functions/jsonEquals";

const EditSectionArrayModal = ({ editSectionModal,
    setEditSectionModal, sectionState, setSectionState }) => {

    const [titleListState, setTitleListState] = useState([]);
    const [titleListIndexState, setTitleListIndexState] = useState({});
    const [startingTitleListIndexState, setStartingTitleListIndexState] = useState({});
    const [newSectionTitleState, setNewSectionTitleState] = useState({ "title": "", "addSection": false });

    useEffect(() => {
        let startingTitleListIndex = {};
        let startingTitleList = [];
        if (sectionState.section.length) {
            for (const index in sectionState.section) {
                let title = sectionState.section[index].title ||
                    sectionState.section[index].code?.coding?.[0]?.display ||
                    sectionState.section[index].code?.coding?.[0]?.code ||
                    sectionState.section[index].code?.text ||
                    sectionState.section[index].focus?.display ||
                    sectionState.section[index].focus?.reference ||
                    "Untitled Unclassified Section";
                startingTitleListIndex[title] = parseInt(index) + 1;
                startingTitleList.push(title);
            }
        }
        setTitleListState(startingTitleList);
        setTitleListIndexState(startingTitleListIndex);
        setStartingTitleListIndexState(startingTitleListIndex);
    }, [sectionState.section]);

    useEffect(() => {
        if (newSectionTitleState.addSection && newSectionTitleState.title) {
            setTitleListState(prevState => {
                let newTitleList = JSON.parse(JSON.stringify(prevState));
                if (!newTitleList.includes(newSectionTitleState.title)) {
                    newTitleList.push(newSectionTitleState.title);
                }
                return newTitleList;
            });
            setTitleListIndexState(prevState => {
                return { ...prevState, [newSectionTitleState.title]: Object.keys(prevState).length + 1 };
            });
            setNewSectionTitleState(prevState => {
                return { ...prevState, "addSection": false };
            });
        }
    }, [newSectionTitleState]);

    useEffect(() => {
        if (!jsonEquals(titleListIndexState, startingTitleListIndexState)) {
            let titleList = [];
            for (let title of Object.keys(titleListIndexState)) {
                if (titleListIndexState[title] !== "DELETEME") {
                    titleList.push(title);
                }
            }
            titleList.sort((a, b) => {
                if (titleListIndexState[a] < titleListIndexState[b]) {
                    return -1;
                } else if (titleListIndexState[a] > titleListIndexState[b]) {
                    return 1;
                }
                return 0;
            });
            setSectionState(prevState => {
                let oldSections = prevState.section;
                let sectionDictionary = {};
                for (let section of oldSections) {
                    sectionDictionary[section.title] = section;
                }
                let newSections = [];
                for (let title of titleList) {
                    if (sectionDictionary[title]) {
                        newSections.push(sectionDictionary[title]);
                    } else {
                        newSections.push({ "title": title, "code": { "text": title.replaceAll(" ", "-") } });
                    }
                }
                return { ...prevState, "section": newSections };
            })
        }
    }, [titleListIndexState, startingTitleListIndexState, setSectionState]);

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
            className="formButton negative"
            content="✖"
            onClick={() => {
                setEditSectionModal(prevState => { return { ...prevState, openModal: false }; });
            }} />
        {titleListState?.length > 0 && titleListState.map((title, titleIndex) => {
            return <div key={titleIndex}>
                <span>
                    <TextField style={{ width: "100%", marginTop: "12px", maxWidth: "60px" }}
                        className="inputField" type='text'
                        label={"Index"} size="small" variant='outlined'
                        value={titleListIndexState[title]}
                        onChange={(e) => {
                            if (e.target.value && !isNaN(e.target.value)) {
                                if ((parseInt(e.target.value) !== parseFloat(e.target.value)) || parseInt(e.target.value) < 0) {
                                    alert("Only positive integers are allowed.");
                                }
                            }
                            if (e.target.value === "d" || e.target.value === "D") {
                                setTitleListIndexState(prevState => { return { ...prevState, [title]: "DELETEME" } });
                            } else if (isNaN(e.target.value)) {
                                alert("Only positive integers are allowed, or d or D to delete.");
                            } else if (!isNaN(e.target.value)) {
                                setTitleListIndexState(prevState => {
                                    let oldNumber = prevState[title];
                                    let newNumber = Number(e.target.value);
                                    if (newNumber > oldNumber) {
                                        return { ...prevState, [title]: newNumber + 0.1 };
                                    } else {
                                        return { ...prevState, [title]: newNumber - 0.1 };
                                    }
                                });
                            }
                        }} />
                    {title}
                </span>
            </div>
        })}
        <h2>Add a section</h2>
        <TextField style={{ width: "100%" }} className="inputField"
            type='text' variant='outlined'
            placeholder='Enter section title.' value={newSectionTitleState.title}
            onKeyUp={(event) => {
                if (event.key === 'Enter') {
                    setNewSectionTitleState(prevState => {
                        return {
                            ...prevState,
                            "addSection": true
                        }
                    });
                }
            }}
            onChange={(e) => {
                setNewSectionTitleState(prevState => {
                    return {
                        ...prevState,
                        "title": e.target.value || ""
                    }
                });
            }} />
        <br />
    </div>;

    return <Modal
        style={{ padding: "0px", margin: "0px" }}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        open={editSectionModal?.openModal}
        centered={false}
        content={modalContent}
    />;
};

export default EditSectionArrayModal;